import React from 'react'

const Forrentsec3 = () => {
  return (
    <div>
        <div className='forrentsignin'>
            <h3>Sign in to enjoy much more</h3>
            <p>Tired of endless tabs cluttering your browser while you search for your ideal property? We've got the solution for you! Say farewell to the tab chaos and hello to organization with our cutting-edge platform.</p>
            <button>+ sign in</button>
        </div>
    </div>
  )
}

export default Forrentsec3